module.exports = __webpack_public_path__ + "img/changfang1_tu.aa9a968f.png";